import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import team3 from '../../../assets/img/team/3.jpg';
import usuario_img from '../../../assets/img/team/user_2.png'
import Avatar from '../../../components/common/Avatar';
import { AuthContext } from '../../../contexts/AuthContext';
import paths from '../../../routes/paths';

const ProfileDropdown = () => {
  const { logout, usuario } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate(paths.splitLogin);
  };

  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 ps-2 nav-link"
      >
        <Avatar src={usuario_img} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          {
            /*
            <Dropdown.Item className="fw-bold text-danger" href="#!">
            <FontAwesomeIcon icon="crown" className="me-1" />
            <span>Acciones</span>
          </Dropdown.Item>
            */
          }
          <Dropdown.Divider />
          <Dropdown.Item as={Link} to="#!" onClick={handleLogout}>
            Cerrar Sesión
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
